import { StatutJuridiqueFilleul } from '@lib/models/demande-affiliation/types/statut-juridique-filleul.type';

export class StatutJuridiqueMapper {
  public static fromGraphQl(input?: string | null): StatutJuridiqueFilleul | undefined {
    const mapping: Record<string, StatutJuridiqueFilleul> = {
      SOCIETE: 'societe',
      PROFESSION_LIBERALE: 'profession_liberale',
      AGENT_COMMERCIAL: 'agent_commercial',
    };
    return input ? mapping[input] : undefined;
  }

  public static fromAtlas(input?: string | null): StatutJuridiqueFilleul | undefined {
    const mapping: Record<string, StatutJuridiqueFilleul> = {
      '3': 'societe',
      '2': 'profession_liberale',
      '1': 'agent_commercial',
    };
    return input ? mapping[input] : undefined;
  }
}
